export function Gallery() {
    return (
        <section className="gallery-main-section">
            <div className="gallery-img">
                <p>Desarrollo de procesos internacionales para la apertura de sucursales en el
                    extranjero.</p>
            </div>
            <div className="gallery-img">
                <p>Suministro, e instalación de sistemas de aire acondicionado habitacional e
                    industrial, en Cancún, Quintana Roo y Villahermosa, Tabasco.</p>
            </div>
            <div className="gallery-img">
                <p>Diseño de diagramas de instalación de aire acondicionado.</p>
            </div>
            <div className="gallery-img">
                <p>Planeación de infraestructura para plantas industriales.</p>
            </div>
            <div className="gallery-img">
                <p>Mantenimiento y Reparación de sistemas de aire acondicionado.</p>
            </div>
            <div className="gallery-img">
                <p>Sistemas VRV Y VRF</p>
            </div>
            <div className="gallery-img">
                <p>Sistemas de recoleccion de polvos</p>
            </div>
        </section>
    )
}